/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

document.addEventListener("DOMContentLoaded", function () {
    const stickyButton = document.querySelector('.sticky_10off');
    const closeStickyButton = document.querySelector('.close-sticky');
    const popup = document.querySelector('[data-popup]');
    const closePopupButton = popup ? popup.querySelector('[data-popup-close]') : null;
    const popupOverlay = document.querySelector('.popup__underlay');

    if (!stickyButton || !popup) {
        console.error("Sticky button or popup not found!");
        return;
    }

    console.log("Sticky button and popup found!");

    // Show sticky button when scrolling down
    window.addEventListener('scroll', function () {
        if (window.scrollY > 200) {
            stickyButton.classList.add("show");
        }
    });

    // Open the popup when the sticky button is clicked
    stickyButton.addEventListener('click', function () {
        console.log("Sticky button clicked, opening popup...");
        popup.style.display = 'block';
        popup.classList.add("active");

        if (popupOverlay) {
            popupOverlay.style.display = 'block';
            popupOverlay.classList.add("active");
        }

        // Fix form interactivity
        const formElements = popup.querySelectorAll('input, textarea, button');
        formElements.forEach(el => {
            el.removeAttribute('disabled'); // Ensure inputs are active
            el.style.pointerEvents = 'auto';
        });
    });

    // Close the popup when the close button is clicked
    if (closePopupButton) {
        closePopupButton.addEventListener('click', function () {
            console.log("Popup close button clicked, hiding popup...");
            popup.classList.remove("active");
            popup.style.display = 'none';

            if (popupOverlay) {
                popupOverlay.classList.remove("active");
                popupOverlay.style.display = 'none';
            }
        });
    }

    // Hide the sticky button when close is clicked
    closeStickyButton.addEventListener('click', function (event) {
        event.stopPropagation();
        stickyButton.style.display = 'none';
    });
});

console.log("Custom.js is working");

document.addEventListener("DOMContentLoaded", function () {
  var slider = document.querySelector('[data-slider]');
  if (!slider) return;
  
  var flkty = Flickity.data(slider);

  document.querySelector(".custom-arrow--prev").addEventListener("click", function () {
    flkty.previous();
  });

  document.querySelector(".custom-arrow--next").addEventListener("click", function () {
    flkty.next();
  });
});

document.addEventListener('DOMContentLoaded', () => {
    console.log("Script Loaded: Listening for size selections...");

    // Use event delegation to capture clicks on size buttons (works even for dynamically loaded elements)
    document.body.addEventListener('click', async (event) => {
        let button = event.target.closest('.ns-hover-sizes, .hover-zark-options'); // Detect click on either class

        if (button) {
            event.preventDefault();
            const variantId = button.getAttribute('data-variant-id');
            console.log('Adding variant to cart:', variantId);

            try {
                let response = await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ id: variantId, quantity: 1 })
                });

                if (!response.ok) {
                    throw new Error('Failed to add item to cart');
                }

                let cartData = await response.json();
                console.log('Product added to cart:', cartData);

                // Store a flag to open cart drawer after refresh
                sessionStorage.setItem("openCartAfterReload", "true");
                hiddenPageRefresh();

            } catch (error) {
                console.error('Error adding to cart:', error);
            }
        }
    });

    // Function to open the cart drawer
    function openCartDrawer() {
        console.log("Attempting to open the cart drawer...");

        let cartButton = document.querySelector(".cart__toggle[data-cart-drawer-toggle]") ||
                         document.querySelector("[data-cart-open]") ||
                         document.querySelector(".cart-icon") ||
                         document.querySelector(".header__icon--cart");

        if (cartButton) {
            console.log("Found cart toggle button.");
            cartButton.click();
            return;
        }

        
        let cartDrawer = document.querySelector("#cart-drawer, .cart-drawer, [data-cart-drawer]");

        if (cartDrawer) {
            console.log("Found cart drawer.");
            cartDrawer.classList.add("is-open");
            cartDrawer.style.display = "block";
            cartDrawer.setAttribute("aria-hidden", "false");

            document.body.classList.add("drawer-open"); 

        } else {
            console.error("Cart drawer not found. Check the selectors.");
        }
    }

    // Refresh the page while keeping the scroll position
    function hiddenPageRefresh() {
        const scrollY = window.scrollY;
        location.reload();
        window.scrollTo(0, scrollY);
    }

    // Open cart drawer after refresh if needed
    if (sessionStorage.getItem("openCartAfterReload") === "true") {
        sessionStorage.removeItem("openCartAfterReload"); 
        setTimeout(() => {
            openCartDrawer();
        }, 500);
    }
});

document.addEventListener('DOMContentLoaded', function () {
    const collectionGrid = document.querySelector('.collection__products');
    const grid2Btn = document.getElementById('grid-2-btn');
    const grid4Btn = document.getElementById('grid-4-btn');
    const mobile1Btn = document.getElementById('mobile-grid-1-btn');
    const mobile2Btn = document.getElementById('mobile-grid-2-btn');

    if (!collectionGrid) {
        console.error("Grid container NOT found! Check class name in Shopify.");
        return;
    }

    // Check if screen is desktop
    function isDesktop() {
        return window.innerWidth >= 1024;
    }

    function isMobile() {
        return window.innerWidth < 1024;
    }

    // Function to update grid layout for desktop
    function updateGridVariables(columns) {
        if (!isDesktop()) return; // Stop if not desktop

        const root = document.documentElement;
        let columnValue = `repeat(${columns}, 1fr)`;

        root.style.setProperty('--grid', columnValue);

        grid2Btn.classList.toggle('active', columns === 2);
        grid4Btn.classList.toggle('active', columns === 4);

        if (columns === 2) {
            collectionGrid.classList.add('grid-2');
            collectionGrid.classList.remove('grid-4');
        } else {
            collectionGrid.classList.add('grid-4');
            collectionGrid.classList.remove('grid-2');
        }

        localStorage.setItem('gridColumns', columns);
    }

function updateMobileGrid(columns) {
    if (!isMobile()) return; // Stop if not mobile

    if (columns === 1) {
        collectionGrid.classList.add('mobile-grid-1');
        collectionGrid.classList.remove('mobile-grid-2');
    } else {
        collectionGrid.classList.remove('mobile-grid-1');
        collectionGrid.classList.remove('mobile-grid-2'); // Reset to default layout
    }

    // Update active button UI
    mobile1Btn.classList.toggle('active', columns === 1);
    mobile2Btn.classList.toggle('active', columns === 2);

    // Save user preference
    localStorage.setItem('mobileGridColumns', columns);
}



    // Desktop Button Event Listeners
    grid2Btn.addEventListener('click', () => updateGridVariables(2));
    grid4Btn.addEventListener('click', () => updateGridVariables(4));

    // Mobile Button Event Listeners
    mobile1Btn.addEventListener('click', () => updateMobileGrid(1));
    mobile2Btn.addEventListener('click', () => updateMobileGrid(2));

    // Load saved grid preference (Desktop default is 4)
    if (isDesktop()) {
        const savedColumns = localStorage.getItem('gridColumns');
        updateGridVariables(savedColumns ? parseInt(savedColumns, 10) : 4);
    }

    // Load saved grid preference (Mobile default is 2)
    if (isMobile()) {
        const savedMobileColumns = localStorage.getItem('mobileGridColumns');
        updateMobileGrid(savedMobileColumns ? parseInt(savedMobileColumns, 10) : 2);
    }

    // Hide buttons if not on the right screen size
    function toggleButtonsVisibility() {
        const desktopButtons = document.querySelector('.grid-toggle-container');
        const mobileButtons = document.querySelector('.mobile-grid-toggle-container');

        if (!isDesktop()) {
            desktopButtons.style.display = 'none';
        } else {
            desktopButtons.style.display = 'flex';
        }

        if (!isMobile()) {
            mobileButtons.style.display = 'none';
        } else {
            mobileButtons.style.display = 'flex';
        }
    }

    // Check on window resize
    window.addEventListener('resize', toggleButtonsVisibility);
    toggleButtonsVisibility();
});

document.addEventListener("DOMContentLoaded", function () {
    function getDropdownFamilyByText(text) {
        let elements = document.querySelectorAll('.dropdown__family > .navlink--child .navtext');
        for (let element of elements) {
            if (element.textContent.trim() === text) {
                return element.closest('.dropdown__family');
            }
        }
        return null;
    }

    // Get the "NEW" section (Target Parent)
    let targetParent = getDropdownFamilyByText("NEW");

    // Get the "SALE" section (Div to Move)
    let divToMove = getDropdownFamilyByText("SALE");

    if (targetParent && divToMove && targetParent !== divToMove) {
        targetParent.appendChild(divToMove);
    }
});


document.addEventListener("DOMContentLoaded", function () {
    function getDropdownFamilyByText(text) {
        let xpath = `//a[contains(@class, 'navlink--child')]/span[contains(text(), '${text}')]/parent::a/parent::div`;
        let result = document.evaluate(xpath, document, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null);
        return result.singleNodeValue;
    }

    // Get ΠΑΠΟΥΤΣΙΑ and ΔΩΡΟΚΑΡΤΑ sections
    let shoesParent = getDropdownFamilyByText("ΣΥΛΛΟΓΕΣ");
    let giftCardDiv = getDropdownFamilyByText("ΔΩΡΟΚΑΡΤΑ");

    if (shoesParent && giftCardDiv && shoesParent !== giftCardDiv) {
        shoesParent.appendChild(giftCardDiv);
    }
});


document.addEventListener("DOMContentLoaded", function () {
    function moveDropdownItem(parentText, childText) {
        let parentDropdown = null;
        let childDropdown = null;

        // Find all dropdown families
        let dropdowns = document.querySelectorAll('.dropdown__family');

        dropdowns.forEach(dropdown => {
            let parent = dropdown.querySelector('.navlink--child .navtext');
            if (parent && parent.textContent.trim() === parentText) {
                parentDropdown = dropdown;
            }

            let child = dropdown.querySelector('.navlink--child .navtext');
            if (child && child.textContent.trim() === childText) {
                childDropdown = dropdown;
            }
        });

        // Move childDropdown inside parentDropdown if both exist
        if (parentDropdown && childDropdown && parentDropdown !== childDropdown) {
            parentDropdown.appendChild(childDropdown);
        }
    }

    // Move "SALE" inside "NEW"
    moveDropdownItem("NEW", "SALE");

    // Move "ΔΩΡΟΚΑΡΤΑ" inside "ΣΥΛΛΟΓΕΣ"
    moveDropdownItem("ΣΥΛΛΟΓΕΣ", "ΔΩΡΟΚΑΡΤΑ");

  
});

   // Slider
document.addEventListener("DOMContentLoaded", function () {
    console.log(" Initializing product grid sliders...");

    function initializeProductSliders() {
        document.querySelectorAll(".custom-product-slider").forEach((slider, sliderIndex) => {
            let slides = slider.querySelectorAll(".custom-slide");
            let prevBtn = slider.querySelector(".prev-btn");
            let nextBtn = slider.querySelector(".next-btn");
            let lazyImage = slider.closest(".product__media__container").querySelector(".product__media__image");

            if (!slides.length || !prevBtn || !nextBtn) {
                console.warn(`Slider ${sliderIndex} missing elements.`);
                return;
            }

            // Retrieve previous index if available
            let currentIndex = parseInt(slider.dataset.currentIndex || "0", 10);

            function updateSlides() {
                slides.forEach((slide, index) => {
                    slide.style.display = index === currentIndex ? "block" : "none";
                    slide.style.opacity = index === currentIndex ? "1" : "0";
                    slide.style.visibility = index === currentIndex ? "visible" : "hidden";
                    slide.style.zIndex = index === currentIndex ? "2" : "1";
                });

                // Store current index to prevent reset
                slider.dataset.currentIndex = currentIndex;

                // Hide lazy image when slider is used
                if (lazyImage) {
                    lazyImage.style.display = "none";
                }

                console.log(`Product image changed to index: ${currentIndex} in slider ${sliderIndex}`);
            }

            prevBtn.addEventListener("click", function (event) {
                event.preventDefault();
                event.stopPropagation();
                currentIndex = (currentIndex - 1 + slides.length) % slides.length;
                updateSlides();
            });

            nextBtn.addEventListener("click", function (event) {
                event.preventDefault();
                event.stopPropagation();
                currentIndex = (currentIndex + 1) % slides.length;
                updateSlides();
            });

            updateSlides();
        });
    }

    initializeProductSliders(); 

    // Prevent MutationObserver from resetting images
    const observer = new MutationObserver(() => {
        console.log("♻DOM changed, preserving slider state...");
        initializeProductSliders();
    });

    observer.observe(document.body, { childList: true, subtree: true });
});


document.addEventListener("DOMContentLoaded", function () {
    const filterContainer = document.querySelector(".collection__filters");
    const collectionGrid2 = document.querySelector(".collection__products.grid-2");

    if (filterContainer && collectionGrid2) {
        const updateClass = () => {
            if (filterContainer.classList.contains("active")) {
                collectionGrid2.classList.add("filters-open");
            } else {
                collectionGrid2.classList.remove("filters-open");
            }
        };

        // Observe class changes on the filter container
        const observer = new MutationObserver(updateClass);
        observer.observe(filterContainer, { attributes: true, attributeFilter: ["class"] });

        // Ensure class is set correctly on page load
        updateClass();
    }
});

document.addEventListener("DOMContentLoaded", function () {
  // Run only on mobile devices
  if (window.matchMedia('(max-width: 767px)').matches) {
    
    // Try a smaller number (e.g., 40) to ensure it fits a single line
    const SINGLE_LINE_CHAR_LIMIT = 40;

    // Target all .text__content elements
    const blocks = document.querySelectorAll('.text__content');
    
    blocks.forEach(function(block) {
      const fullText = block.textContent.trim();
      if (fullText.length <= SINGLE_LINE_CHAR_LIMIT) return;
      
      // Build truncated text
      const truncatedText = fullText.slice(0, SINGLE_LINE_CHAR_LIMIT) + '... ';
      
      // Clear existing content
      block.innerHTML = '';
      
      // Create truncated text node
      const truncatedNode = document.createTextNode(truncatedText);
      block.appendChild(truncatedNode);

      // Create “Read more” link
      const readMoreLink = document.createElement('a');
      readMoreLink.href = '#';
      readMoreLink.textContent = 'Read more';

      // Make link the same color, but underlined
      readMoreLink.style.color = 'inherit';
      readMoreLink.style.textDecoration = 'underline';

      block.appendChild(readMoreLink);
      
      // Expand full text on click
      readMoreLink.addEventListener('click', function(e) {
        e.preventDefault();
        block.textContent = fullText + ' ';
        
        // “Read less” link
        const readLessLink = document.createElement('a');
        readLessLink.href = '#';
        readLessLink.textContent = 'Read less';
        readLessLink.style.color = 'inherit';
        readLessLink.style.textDecoration = 'underline';
        
        block.appendChild(readLessLink);

        readLessLink.addEventListener('click', function(e2) {
          e2.preventDefault();
          // revert to truncated
          block.innerHTML = '';
          block.appendChild(truncatedNode);
          block.appendChild(readMoreLink);
        });
      });
    });
  }
});

document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll(".popup__description br").forEach(br => br.remove());
});

  document.addEventListener("DOMContentLoaded", function() {
    if (window.location.pathname.includes('/collections/')) {
      document.documentElement.style.overflowX = "hidden";
      document.body.style.overflowX = "hidden";
      document.body.style.width = "100vw"; // Ensures the body doesn't exceed viewport width
    }
  });

document.addEventListener('DOMContentLoaded', function() {
    // Use event delegation for dynamically added elements
    document.body.addEventListener('click', function(event) {
        const button = event.target.closest('.product__submit__add');
        if (!button) return;  // Ignore clicks outside "Add to Cart" buttons

        event.preventDefault();  // Prevent form submission

        const form = button.closest('form');
        if (!form) return;

        const formData = new FormData(form);

        // Add item to the cart via Shopify AJAX API
        fetch('/cart/add.js', {
            method: 'POST',
            body: formData
        })
        .then(response => response.json())
        .then(data => {
            console.log('Item added to cart:', data);

            // Wait for Shopify to update the cart drawer
            setTimeout(updateCartBubbleFromDrawer, 500);
        })
        .catch(error => {
            console.error('Error adding item to cart:', error);
            alert('There was an error adding the item to the cart. Please try again.');
        });
    });

    let lastKnownCartCount = 0; // Stores the last valid cart count

    // Function to update the cart bubble using the cart drawer's quantity
    function updateCartBubbleFromDrawer() {
        const cartQtyElement = document.querySelector('.cart-drawer__item-qty[data-cart-items-qty]');

        if (cartQtyElement) {
            const cartItemsCount = parseInt(cartQtyElement.textContent) || 0;

            if (!cartQtyElement.classList.contains('hidden')) {
                // Normal case: The cart drawer is visible, so we trust the count
                lastKnownCartCount = cartItemsCount;
                updateCartBubble(lastKnownCartCount);
            } else {
                // Shopify hides it, we double-check by fetching the real cart count from Shopify's API
                fetch('/cart.js')
                .then(response => response.json())
                .then(cart => {
                    const confirmedCartCount = cart.item_count;
                    lastKnownCartCount = confirmedCartCount;
                    updateCartBubble(lastKnownCartCount);
                })
                .catch(error => {
                    console.error('Error fetching cart data:', error);
                });
            }
        }
    }

    // Function to update all cart bubbles on the page
    function updateCartBubble(count) {
        document.querySelectorAll('.cart-icon-zark').forEach(cartIconBubble => {
            cartIconBubble.textContent = count;
            cartIconBubble.classList.toggle('hidden', count === 0);
        });

        console.log(`Cart bubble updated: ${count}`);
    }

    // Observe cart drawer changes to update the cart bubble dynamically
    const observer = new MutationObserver(updateCartBubbleFromDrawer);
    const cartDrawer = document.querySelector('.cart-drawer__item-qty[data-cart-items-qty]');

    if (cartDrawer) {
        observer.observe(cartDrawer, { childList: true, subtree: true, characterData: true });
    }
});

document.addEventListener('DOMContentLoaded', () => {
  const observer = new MutationObserver(() => {
    const formEmbed = document.querySelector('form-embed');

    if (formEmbed && formEmbed.shadowRoot) {
      observer.disconnect();

      const shadow = formEmbed.shadowRoot;

      const styleSheet = new CSSStyleSheet();
      styleSheet.replaceSync(`
        /* Teaser Button */
        button[data-testid="teaser-container"] {
          all: unset !important;
          position: fixed !important;
          top: 50% !important;
          left: 0px !important;
          transform: translateY(-70%)!important;
          transform-origin: top left !important;
          background-color: rgb(235, 234, 230) !important;
          padding: 8px 25px !important;
          font-size: 14px !important;
          font-family: sans-serif !important;
          font-weight: bold !important;
          color: rgb(0, 0, 0) !important;
          cursor: pointer !important;
          z-index: 2147483647 !important;
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          gap: 10px !important;
          border: medium !important;
          box-shadow: rgba(0, 0, 0, 0.1) 0px 2px 8px !important;
          min-width: 90px !important;
        }

        /* Teaser Message */
        h3[data-testid="teaser-message"] {
          all: unset !important;
          color: rgb(0, 0, 0) !important;
          font-size: 14px !important;
          font-weight: bold !important;
          font-family: sans-serif !important;
        }

        /* Close Button */
        span[data-testid="btn-close"] {
          all: unset !important;
          display: inline-flex !important;
          align-items: center !important;
          justify-content: center !important;
          width: 16px !important;
          height: 16px !important;
          font-size: 16px !important;
          color: rgb(0, 0, 0) !important;
          cursor: pointer !important;
        }

        span[data-testid="btn-close"]:hover {
          color: red !important;
        }

        @media screen and (max-width: 768px) {
          button[data-testid="teaser-container"] {
            font-size: 12px !important;
            padding: 6px 14px !important;
            
          }
        }
      `);

      shadow.adoptedStyleSheets = [...shadow.adoptedStyleSheets, styleSheet];
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});


 

  document.addEventListener('click', function (e) {
    const target = e.target.closest('.wishlist-move-cart');
    if (target) {
      localStorage.setItem('openCartAfterReload', 'true');
      setTimeout(() => {
        location.reload();
      }, 500);
    }
  });

 
  document.addEventListener('DOMContentLoaded', function () {
    if (localStorage.getItem('openCartAfterReload') === 'true') {
      localStorage.removeItem('openCartAfterReload');

      
      const toggle = document.querySelector('[data-cart-drawer-toggle]');
      if (toggle) {
        toggle.click(); // Open it the theme's way
      } else {
        // Fallback: forcibly make it visible
        document.body.classList.add('cart-drawer--visible');
      }
    }
  });

function updateWishlistHeaderBubble(count) {
  const icon = document.querySelector('.ns-wishlist-icon');
  if (!icon) return;

  let bubble = icon.querySelector('.wishlist-bubble');
  if (!bubble) {
    bubble = document.createElement('span');
    bubble.className = 'wishlist-bubble';
    icon.appendChild(bubble);
  }

  bubble.textContent = count;
  bubble.style.display = count > 0 ? 'inline-block' : 'none';

  bubble.style.cssText = `
    color: #000;
    font-size: 10px;
    font-weight: 500;
    height: 20px;
    left: 27px;
    line-height: 20px;
    min-width: 20px;
    padding: 0 2px;
    position: absolute;
    text-align: left;
    top: 4px;
    border-radius: 999px;
  `;
}

function getWishlistCount() {
  const isWishlistPage = document.querySelector('.wishlist-page');
  let variantIds = [];

  if (isWishlistPage) {
    const checkboxes = document.querySelectorAll('.wishlist_item_checkbox[data-variant_id]');
    variantIds = [...checkboxes].map(el => el.getAttribute('data-variant_id'));
  } else {
    const buttons = document.querySelectorAll('.wishlist-engine[data-added="true"][data-variant_id]');
    variantIds = [...buttons].map(el => el.getAttribute('data-variant_id'));
  }

  // Filter and deduplicate
  const uniqueIds = variantIds.filter(Boolean).map(id => id.trim());
  const count = new Set(uniqueIds).size;

  // Store to localStorage as a backup
  if (count > 0) {
    localStorage.setItem('wishlist_count', count.toString());
  }

  // Fallback to localStorage if no items found
  if (count === 0) {
    const stored = parseInt(localStorage.getItem('wishlist_count') || '0', 10);
    return stored;
  }

  return count;
}

function syncWishlistBubble() {
  const count = getWishlistCount();
  updateWishlistHeaderBubble(count);
}

function observeWishlistChanges() {
  const container =
    document.querySelector('#wishlist-page-contain') ||
    document.querySelector('.wishlist-page');

  if (!container) return;

  const observer = new MutationObserver(syncWishlistBubble);
  observer.observe(container, {
    childList: true,
    attributes: true,
    subtree: true,
  });
}

document.addEventListener('DOMContentLoaded', () => {
  const isWishlistPage = document.querySelector('.wishlist-page');

  if (isWishlistPage) {
    let attempts = 0;
    const maxAttempts = 30;
    const waitForRender = setInterval(() => {
      const items = document.querySelectorAll('.wishlist_item_checkbox[data-variant_id]');
      if (items.length > 0 || attempts >= maxAttempts) {
        clearInterval(waitForRender);
        syncWishlistBubble();
        observeWishlistChanges();
      }
      attempts++;
    }, 200);
  } else {
    syncWishlistBubble();
  }
});

// Handle changes from button clicks
document.addEventListener('click', function (e) {
  const triggers = [
    '.wishlist-engine-button',
    '.wishlist_page_remove_product',
    '.wishlist-variant-picker',
  ];
  if (triggers.some(sel => e.target.closest(sel))) {
    setTimeout(syncWishlistBubble, 300);
  }
});

// Cross-tab sync
window.addEventListener('storage', syncWishlistBubble);

// Fallback check every 5s
setInterval(syncWishlistBubble, 5000);


document.addEventListener('DOMContentLoaded', function () {
  const filters = document.querySelector('.collection__filters-list');
  const toggleDesktop = document.querySelector('#toggleFilters'); // Desktop button
  const toggleMobile = document.querySelector('[data-toggle-filters]'); // Mobile button

  if (!filters) return;

  let filtersVisible = false;

  function toggleFilters() {
    filtersVisible = !filtersVisible;
    filters.style.display = filtersVisible ? 'block' : 'none';
    filters.style.height = filtersVisible ? 'auto' : '0';
    filters.style.padding = filtersVisible ? '' : '0';
    filters.style.margin = filtersVisible ? '' : '0';
  }

  filters.style.display = 'none'; // Hide on page load

  if (toggleDesktop) toggleDesktop.addEventListener('click', toggleFilters);
  if (toggleMobile) toggleMobile.addEventListener('click', toggleFilters);
});


  document.addEventListener('DOMContentLoaded', function () {
  const radios = document.querySelectorAll('input[name="options[ΜΕΓΕΘΟΣ]"]');

  radios.forEach(radio => {
    if (radio.value.trim().toLowerCase() === "one size") {
      radio.checked = true;
    } else {
      radio.checked = false;
    }
  });
});


  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
